import { ButtonGroup, Col, Row } from "react-bootstrap";
import styles from "./app-tabs.module.scss";

export interface TabComponentInterface {
  buttonName: string;
  selectedColor: "lightBlue" | "lightGreen" | "blueColor" | "tabButtonWhite";
  id: number;
}

interface IProps {
  buttons: TabComponentInterface[];
  onChange: (id: number) => void;
  selectedTabId: number;
}

const AppTabs = (props: IProps) => {
  const { buttons, onChange, selectedTabId } = props;

  return (
    <ButtonGroup className={`${styles.tabButtonGroup}`}>
      <Row className="w-100 m-0">
        {buttons.map((button) => {
          return (
            <Col
              key={button.id}
              className={`${styles.tabButton} ${
                selectedTabId === button.id
                  ? styles[button.selectedColor]
                  : styles.tabButtonWhite
              } font-size-12 px-3`}
              onClick={() => {
                onChange(button.id);
              }}
            >
              {button.buttonName}
            </Col>
          );
        })}
      </Row>
    </ButtonGroup>
  );
};

export default AppTabs;
